export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const WILKER = '/wilker';
export const WILKER_FORMUJI = '/wilker-formuji';
export const WILKER_FORMUJIADD = '/wilker-formuji/add';
export const WILKER_FORMUJIDETAIL = '/wilker-formuji/:id';
export const ADMIN = '/admin';
export const ADMIN_DETAILS = '/admin/:id';
export const MASTERDATASAMPLE = '/masterdatasample';
export const MASTERDATASAMPLEDETAIL = '/masterdatasample/:id';
export const MASTERDATAPENGUJIAN = '/masterdata-pengujian';
export const MASTERDATAPENGUJIANDETAIL = '/masterdata-pengujian/:id';
export const MASTERDATA_WILKER = '/masterdata-wilker';
export const MASTERDATA_WILKERDETAIL = '/masterdata-wilker/:id';
export const ADMINLAB = '/adminlab';
export const ADMINLAB_DETAIL = '/adminlab/:id';
export const ANALIS = '/analis';
export const ANALIS_DETAIL = '/analis/:id';
export const ANALIS_ALATBAHAN = '/analis-alat-bahan';
export const MASTERDATA_BAHAN = '/masterdata-bahan';
export const MASTERDATA_BAHANDETAIL = '/masterdata-bahan/:id';
export const MASTERDATA_USERFORM = '/masterdata-userform';
export const MASTERDATA_USERFORMDETAIL = '/masterdata-userform/:id';
export const TEKNIS = '/teknis';
export const TEKNIS_DETAILS = '/teknis/:id';
